// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jmZT6","selected":"styles_selected__hzW93"};